var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 50,
    viewBox: "0 0 100 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8 25.2L65.3 7V18.5H3V31.9H65.3V43.4L96.8 25.2Z",
    fill: "#8BC500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIc);
export default __webpack_public_path__ + "static/media/arrow_ic.78806b7edb3264860343aa18cd435dda.svg";
export { ForwardRef as ReactComponent };